import { action } from 'easy-peasy';
import { IActionSetClientAllocation } from '../types';

const setClientAllocation: IActionSetClientAllocation = action((state, payload) => {
  state.current = payload;
});

export default setClientAllocation;
